var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.buttonClasses,attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._t("left-icon"),_c('span',[_vm._t("default",function(){return [_vm._v("Default Text")]})],2),_vm._t("right-icon")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }